import React, { useEffect, useState } from "react";
import { CalendarDays, ChevronLeft, ChevronRight, Truck, Package } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, Loading, PageHeader } from "@/components/common";

const DOW = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];

export default function Calendar() {
  const { branch } = useAuth();
  const [cursor, setCursor] = useState(new Date());
  const [days, setDays] = useState({});
  const [loading, setLoading] = useState(true);
  const month = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, "0")}`;

  useEffect(() => {
    setLoading(true);
    const p = { month }; if (branch) p.branch_id = branch.id;
    api.get("/orders/calendar", p).then((d) => setDays(d.days || {})).finally(() => setLoading(false));
  }, [month, branch]);

  const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const startPad = first.getDay();
  const daysInMonth = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
  const cells = [...Array(startPad).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  const monthName = first.toLocaleDateString("id-ID", { month: "long", year: "numeric" });

  return (
    <>
      <PageHeader title="Kalender Order" subtitle={branch?.name} icon={CalendarDays}
        actions={
          <div className="flex items-center gap-2">
            <button onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))} className="w-9 h-9 rounded-lg border border-slate-300 flex items-center justify-center"><ChevronLeft size={18} /></button>
            <span className="font-medium text-slate-700 w-40 text-center">{monthName}</span>
            <button onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))} className="w-9 h-9 rounded-lg border border-slate-300 flex items-center justify-center"><ChevronRight size={18} /></button>
          </div>
        } />
      {loading ? <Loading /> : (
        <Card className="p-4">
          <div className="grid grid-cols-7 gap-2">
            {DOW.map((d) => <div key={d} className="text-center text-xs font-semibold text-slate-400 py-2">{d}</div>)}
            {cells.map((day, i) => {
              if (!day) return <div key={i} />;
              const key = `${month}-${String(day).padStart(2, "0")}`;
              const info = days[key];
              const isToday = new Date().toISOString().slice(0, 10) === key;
              return (
                <div key={i} className={`min-h-[84px] rounded-xl border p-2 ${isToday ? "border-primary bg-primary/5" : "border-slate-100"}`}>
                  <div className="text-sm font-medium text-slate-600">{day}</div>
                  {info && (
                    <div className="mt-1 space-y-1">
                      {info.pickup > 0 && <div className="flex items-center gap-1 text-[11px] text-emerald-700 bg-emerald-50 rounded px-1 py-0.5"><Package size={11} /> {info.pickup}</div>}
                      {info.delivery > 0 && <div className="flex items-center gap-1 text-[11px] text-sky-700 bg-sky-50 rounded px-1 py-0.5"><Truck size={11} /> {info.delivery}</div>}
                      {info.urgent > 0 && <div className="text-[11px] text-rose-700 bg-rose-50 rounded px-1 py-0.5">{info.urgent} mendesak</div>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </>
  );
}
